import { render } from "./documentSummary.vue?vue&type=template&id=f43cb4cc"
import script from "./documentSummary.vue?vue&type=script&lang=js"
export * from "./documentSummary.vue?vue&type=script&lang=js"

import "./documentSummary.vue?vue&type=style&index=0&id=f43cb4cc&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__